
import axios from '../../http/index';

const getXApiKeyHeader = () => {
    try {
        const key = photoOrg && photoOrg.config && photoOrg.config.xApiKey;
        return key ? { 'X-API-Key': key } : {};
    } catch(e) { return {}; }
};

const doApiCall = async (token,uniqPubShareID) => {
    const params = {
        method: 'GET',
        isRquireGSIDHeader: true,
        isRequireOa2Header: true,
        url: photoOrg.config.pict_service+"social/public/" + token + "?getAssetDim=true",
        headers: { ...getXApiKeyHeader() }
      }

    //As per discussion with user assets, based gsid and oa2 - api is mapping album to the sharee
    if(!photoOrg.oauthInfo.oa2 || !photoOrg.oauthInfo.GSID){
        params.isRquireGSIDHeader = false;
        params.isRequireOa2Header = false;
        params.headers = {"GSID" : uniqPubShareID, ...getXApiKeyHeader() }
    }
    try{
        let response = await axios(params)
        console.log("returned response data", response.data);
        return response.data;
    }catch(error){
        photoOrg.clientLogger.error({description: "LIBRARY:API:getAlbumByToken::Exception", errorCode: "LIBRARY:MYPROJECTS", err_desc: error.message, err_stack: error.stack});
    }       
    
    return null;
}
const getAlbumByToken = (token,uniqPubShareID) => {

    return doApiCall(token,uniqPubShareID);   
}



export default getAlbumByToken;